// section id constants
const POST_CHANGE_QUESTIONNAIRE = 'POST_CHANGE_QUESTIONNAIRE';
const ACTUAL_CHANGE_WINDOW = 'ACTUAL_CHANGE_WINDOW';
const POST_CHANGE_COMMS = 'POST_CHANGE_COMMS';


// section titles
const SECTION_TITLES = {
  POST_CHANGE_QUESTIONNAIRE: 'Post Change Questionnaire',
  ACTUAL_CHANGE_WINDOW: 'Actual Change Window',
  POST_CHANGE_COMMS: 'Post Change Comms',
};


// Post Change Questions
const CAUSE_AN_INCIDENT = 'cause_an_incident';
const FOLLOW_APPROVED_PLAN = 'follow_approved_plan';
const CHANGE_REGRESSED = 'change_regressed';
const COMPLETE_WITHIN_APPROVED_WINDOW = 'complete_within_approved_window';
const DELIVER_EXPECTED_BENEFITS = 'deliver_expected_benefits';
const IMPACTED_INVENTORY_UPDATED = 'impacted_inventory_updated';
const ACTUAL_START_DATE = 'actual_start_date';
const ACTUAL_END_DATE = 'actual_end_date';
const STATUS_REASON = 'status_reason';
const CI_UNAVAILABILITY = 'ci_unavailability';
const ADDITIONAL_IMPACT = 'additional_Impact';

// Failure review field ids
const CAUSED_CHANGE_FAILED = 'failure_review_q1';
const IMPACT_SERVICES_CUSTOMERS = 'failure_review_q2';
const IMPACTED_CONTROL = 'failure_review_q3';
const CHANGE_COORDINATOR_NAME = 'change-coordinator-name';
const CHANGE_COORDINATOR_EMAIL = 'change-coordinator-email';
const CHANGE_COORDINATOR_MOBILE_NUMBER = 'change-coordinator-mobile-number';
const CHANGE_IMPLEMENTER_ENGINEER_EMAIL = 'change-implementer-engineer-email';
const CHANGE_IMPLEMENTER_ENGINEER_MOBILE_NUMBER = 'change-implementer-engineer-mobile_number';
const CHANGE_IMPLEMENTER_ENGINEER_NAME = 'change-implementer-engineer-name';
const SERVICE_AFFECTED = 'service_affected';
const ASSOCIATED_INCIDENT_REF = 'associated-incident-ref';
const CAUSED_SERVICE_OUTAGE = 'cause_service_outage';
const DURATION_OF_OUTAGE = 'duration-of-outage';
const REASON_FOR_FAILURE = 'reason_for_failure';
// Failure Review Section 3 Root Cause
const ROOTCAUSE_REASON_ONE = 'root_cause_reason1';
const ROOTCAUSE_REASON_TWO = 'root_cause_reason2';
const ROOTCAUSE_REASON_THREE = 'root_cause_reason3';
const MEASURES_NEEDED = 'measures-needed';
const CORRECTIVE_ACTION_OWNER_NAME = 'corrective_action_owner_name';
const CORRECTIVE_ACTION_OWNER_EMAIL = 'corrective_action_owner_email';
const CORRECTIVE_ACTION_OWNER_MOBILE_NUMBER = 'corrective_action_owner_mobile_number';
const CORRECTIVE_ACTION_COMPLETION = 'corrective_action_completion';
const CORRECTIVE_ACTION_COMPLETION_DATE = 'corrective_action_completion_date';

// Post Change Review is Happy Path answers
const MOBILE_HAPPY_PATH_ANSWERS = {
  [FOLLOW_APPROVED_PLAN]: ['Yes'],
  [DELIVER_EXPECTED_BENEFITS]: ['Yes'],
  // [CAUSED_SERVICE_OUTAGE]: ['Yes'],
  [CAUSE_AN_INCIDENT]: ['No'],
  [COMPLETE_WITHIN_APPROVED_WINDOW]: ['Yes - No Impact'],
  [CHANGE_REGRESSED]: ['No'],
};

const FIXED_HAPPY_PATH_ANSWERS = {
  [FOLLOW_APPROVED_PLAN]: ['10'],
  [DELIVER_EXPECTED_BENEFITS]: ['10'],
  // [CAUSED_SERVICE_OUTAGE]: ['10'],
  [CAUSE_AN_INCIDENT]: ['20'],
  [COMPLETE_WITHIN_APPROVED_WINDOW]: ['10'],
  [CHANGE_REGRESSED]: ['20'],
  [IMPACTED_INVENTORY_UPDATED]: ['10'],
};

const CHECK_FIXED_QUESTIONARIES = [
  CAUSE_AN_INCIDENT,
  FOLLOW_APPROVED_PLAN,
  CHANGE_REGRESSED,
  COMPLETE_WITHIN_APPROVED_WINDOW,
  DELIVER_EXPECTED_BENEFITS,
  // CAUSED_SERVICE_OUTAGE,
  ADDITIONAL_IMPACT,
];

const CHECK_INVENTORY_UPDATED = [
  IMPACTED_INVENTORY_UPDATED,
];

export {
  POST_CHANGE_QUESTIONNAIRE,
  ACTUAL_CHANGE_WINDOW,
  POST_CHANGE_COMMS,
  SECTION_TITLES,
  MOBILE_HAPPY_PATH_ANSWERS,
  FIXED_HAPPY_PATH_ANSWERS,
  CAUSE_AN_INCIDENT,
  FOLLOW_APPROVED_PLAN,
  CHANGE_REGRESSED,
  COMPLETE_WITHIN_APPROVED_WINDOW,
  DELIVER_EXPECTED_BENEFITS,
  CAUSED_SERVICE_OUTAGE,
  IMPACTED_INVENTORY_UPDATED,
  ACTUAL_START_DATE,
  ACTUAL_END_DATE,
  STATUS_REASON,
  CI_UNAVAILABILITY,
  CAUSED_CHANGE_FAILED,
  IMPACT_SERVICES_CUSTOMERS,
  IMPACTED_CONTROL,
  ADDITIONAL_IMPACT,
  CHECK_FIXED_QUESTIONARIES,
  CHECK_INVENTORY_UPDATED,
  CHANGE_COORDINATOR_NAME,
  CHANGE_COORDINATOR_EMAIL,
  CHANGE_COORDINATOR_MOBILE_NUMBER,
  CHANGE_IMPLEMENTER_ENGINEER_NAME,
  CHANGE_IMPLEMENTER_ENGINEER_EMAIL,
  CHANGE_IMPLEMENTER_ENGINEER_MOBILE_NUMBER,
  ASSOCIATED_INCIDENT_REF,
  SERVICE_AFFECTED,
  DURATION_OF_OUTAGE,
  REASON_FOR_FAILURE,
  ROOTCAUSE_REASON_ONE,
  ROOTCAUSE_REASON_TWO,
  ROOTCAUSE_REASON_THREE,
  MEASURES_NEEDED,
  CORRECTIVE_ACTION_OWNER_NAME,
  CORRECTIVE_ACTION_OWNER_EMAIL,
  CORRECTIVE_ACTION_OWNER_MOBILE_NUMBER,
  CORRECTIVE_ACTION_COMPLETION,
  CORRECTIVE_ACTION_COMPLETION_DATE,
};
